import { AfterViewInit, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PortalApiService } from '@app/shared/services/portal-api.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';

@Component({
    selector: 'contact-support',
    imports: [FormsModule, FloatLabelModule, InputTextModule, TextareaModule],
    templateUrl: './contact-support.component.html',
    styleUrl: './contact-support.component.scss'
})
export class ContactSupportComponent implements AfterViewInit {
    @ViewChild('txtName') inputField!: ElementRef;

    @Input() modalId: string

    #portalApiService = inject(PortalApiService)
    #modalService = inject(BsModalService)

    email: string = ''
    name: string = ''
    subject: string = ''
    message: string = ''
    errorMessage: string = ''
    successMessage: string = ''

    readonly emailRegex: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    ngAfterViewInit(): void {
        this.inputField.nativeElement.focus();
    }

    contactSupport() {
        this.#portalApiService.contactSupport(this.name, this.email, this.subject, this.message)
            .subscribe({
                next: (axResponse) => {
                    if (axResponse != null) {
                        if (axResponse.AllOk) {
                            this.successMessage = 'Tack för ditt mail! <br />Vi återkommer så fort som möjligt!';
                        }
                        else {
                            this.errorMessage = axResponse.message;
                        }
                    }
                },
                error: () => this.errorMessage = 'Okänt fel. Kunde inte kontakta supporten. Försök igen senare eller kontakta Svenska Fönster <a style=\"color:#fff;\" href=\"mailto:support.kundportal@svenskafonster.se\">(support.kundportal@svenskafonster.se)</a>'
            })
    }

    validateInputs() {
        this.errorMessage = undefined

        let error: string = ''

        if (this.name === '') {
            error = "- Ditt namn saknas"
        }

        if (this.email === '') {
            if (error !== '') { error += '<br/>'; }
            error += "- Din e-postadress saknas"
        } else if (!this.emailRegex.test(this.email)) {
            if (error !== '') { error += '<br/>'; }
            error += "- e-postadressen är inte giltig"
        }

        if (this.subject === '') {
            if (error !== '') { error += '<br/>'; }
            error += "- Ärende saknas"
        }

        if (this.message === '') {
            if (error !== '') { error += '<br/>'; }
            error += "- Meddelande saknas"
        }

        if (error !== '') {
            this.errorMessage = error;
            return;
        }
    }

    get enableSend(): boolean {
        return this.name !== '' && this.email !== '' && this.emailRegex.test(this.email) && this.subject !== '' && this.message !== '' && !this.errorMessage
    }

    close() {
        this.#modalService.hide(this.modalId)
    }
}
